import { React, useState, useRef, useEffect } from "react";
import styled from "styled-components";
import "../../Assets/Styles/ContactUs/form.css";
import validator from "validator";
import PhoneNumberInput from "./phone-number-input";
// import emailjs from "@emailjs/browser";
import swal from "sweetalert";
import { sendContactUsForm } from "../../api/axios";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const defaultValue = {
  name: "",
  email: "",
  address: "",
  message: "",
  phoneNumber: "+1",
}

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  address: Yup.string()
    .required("Address is required"),
  message: Yup.string()
    .required("Message is required"),
  phoneNumber: Yup.string()
    .min(10, "Phone number must be at least 10 digits")
    .required("Phone number is required"),
});

export default function Form() {
  const [loader, setLoader] = useState(false);
  const form = useRef();

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      setLoader(true);
      const res = await sendContactUsForm(values);
      if (res?.data?.success) {
        swal(
          "Thank you for contacting PawprintID®. Our Customer Care Team will respond to your inquiry within 2 business days.",
          "",
          "success"
        ).then(() => {
          resetForm();
        });
      }
    } catch (error) {
      console.log("error: ", error);
      swal(
        "Oops!",
        "An error occurred while sending your message. Please try again later.",
        "error"
      );
    } finally {
      setLoader(false);
      setSubmitting(false);
    }
  };

  return (
    <Contact>
      <ContactTitle>
        We will get in touch shortly.
      </ContactTitle>
      
      <Formik
        initialValues={defaultValue}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur, isSubmitting, setFieldValue }) => (
          <FormikForm ref={form}>
            <ContactForm>
              <label className="inputTitle" htmlFor="name" style={{marginTop: '5px'}}>
                Name <span style={{color: 'red'}}>*</span>
              </label>
              <Field
                type="text"
                className={`ContactInput ${errors.name && touched.name ? 'error' : ''}`}
                name="name"
                id="name"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage name="name" component="div" className="error-message" />

              <label className="inputTitle" htmlFor="address">
                Address <span style={{color: 'red'}}>*</span>
              </label>
              <Field
                type="text"
                className={`ContactInput ${errors.address && touched.address ? 'error' : ''}`}
                name="address"
                id="address"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage name="address" component="div" className="error-message" />

              <div className="phone">
                <PhoneNumberInput 
                  setToSend={(newValues) => {
                    // Update Formik values when phone number changes
                    if (newValues.phoneNumber) {
                      values.phoneNumber = newValues.phoneNumber;
                    }
                  }} 
                  toSend={values} 
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                  message={errors?.phoneNumber}
                />
              </div>

              <label className="inputTitle" htmlFor="email">
                Email <span style={{color: 'red'}}>*</span>
              </label>
              <Field
                type="email"
                className={`ContactInput ${errors.email && touched.email ? 'error' : ''}`}
                id="email"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="off"
              />
              <ErrorMessage name="email" component="div" className="error-message" />

              <label className="inputTitle">Questions /Comments <span style={{color: 'red'}}>*</span></label>
              <Field
                as="textarea"
                className={`textBox ${errors.message && touched.message ? 'error' : ''}`}
                id="comment"
                name="message"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage name="message" component="div" className="error-message" style={{marginTop: '5px'}}/>

              <SubmitButton>
                <button type="submit" className="submitbtn" disabled={loader || isSubmitting}>
                  {loader ? 'Submitting...' : 'Submit'}
                </button>
              </SubmitButton>
            </ContactForm>
          </FormikForm>
        )}
      </Formik>
    </Contact>
  );
}

const Contact = styled.div`
  display: grid;
  line-height: 170%;
  justify-content: center;
  /* font-family: "omnes", sans-serif;
  font-style: normal; */
  margin: auto;
  align-items: center;
  justify-items: center;
  max-width: 1080px;
  margin-bottom: 50px;
  padding: 0 150px;
  box-sizing: border-box;
  body {
    /* font-family: "omnes", sans-serif; */
  }
  @media (max-width: 720px) {
    max-width: 600px;
    padding: 0px;
    margin: 0 auto;
  }
`;

const ContactTitle = styled.p`
  font-size: clamp(1.2rem, 3vw, 1.5rem);
  text-align: center;
  margin: 0 0 30px 0;
  line-height: 1.4;
  
  @media (max-width: 768px) {
    margin-bottom: 25px;
  }
  @media (max-width: 520px) {
    max-width: 400px;
  }
  @media (max-width: 420px) {
    width: 300px;
  }
  @media (max-width: 305px) {
    width: 290px;
  }
`;

const ContactForm = styled.div`
  display: flex;
  display: grid;
  width: 700px;
  justify-content: space-evenly;
  border-color: #3ca899;
  /* font-family: "omnes", sans-serif;
  font-style: normal; */
  box-sizing: border-box;
  background: rgba(217, 217, 217, 0.3);
  border-radius: 30px;
  line-height: 250%;
  height: auto;
  border: 3px dashed #3ca899;
  border-radius: 30px;
  padding: 7px;
  @media (max-width: 720px) {
    width: 600px;
    margin-bottom: 20px;
  }
  @media (max-width: 620px) {
    width: 500px;
  }
  @media (max-width: 520px) {
    width: 400px;
    border: 2px dashed #3ca899;
  }
  @media (max-width: 420px) {
    width: 300px;
  }
  @media (max-width: 305px) {
    width: 250px;
  }
`;

const SubmitButton = styled.div`
  transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  /* font-family: "omnes", sans-serif;
  font-style: normal; */
  padding-bottom: 20px;
  padding-top: 15px;
  margin: auto;
  width: 180px;
  /* body {
    font-family: "omnes", sans-serif;
  } */
  :hover {
    transform: translateY(-3px);
  }
`;
